module.exports = __webpack_public_path__ + "img/00013.f0d68689.webp";